<template>
  <SfModal size="xs" data-testid="discard-changes-modal" @close="emit('keep')">
    <template #title>
      {{ I18n.t('common.discard_changes_modal.title') }}
    </template>
    <template #body>
      <p
        class="
          tw-m-0
          tw-text-center
          tw-text-[13px]
          tw-leading-[1.4]
          tw-text-sf-slate-dark-1
        "
      >
        {{ I18n.t('common.discard_changes_modal.body') }}
      </p>
    </template>
    <template #footer>
      <SfButtonDs variant="secondary" @click="emit('keep')">
        {{ I18n.t('common.discard_changes_modal.keep_editing') }}
      </SfButtonDs>
      <SfButtonDs variant="primary" @click="emit('discard')">
        {{ I18n.t('common.discard_changes_modal.confirm') }}
      </SfButtonDs>
    </template>
  </SfModal>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfButtonDs } from '@silverfin/ui-components'
import SfModal from '@app/shared/vue/components/sf-modal/sf-modal.vue'

defineOptions({ name: 'DiscardChangesModal' })

const emit = defineEmits<{ keep: []; discard: [] }>()

const I18n = useI18n()
</script>
